import Marquee from "react-fast-marquee";

const BRANDS = [
    "Cisco", "Juniper", "HPE", "Aruba", "Fortinet", "MikroTik", "Ubiquiti",
    "TP-Link", "D-Link", "Netgear", "Synology", "QNAP", "Dell", "Lenovo", "APC",
];

export default function Brands() {
    return (
        <section id="brands" className="py-16 lg:py-20 bg-white border-y border-slate-200" data-testid="brands-section">
            <div className="container-lg">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
                    <div>
                        <span className="text-xs font-bold tracking-[0.24em] uppercase text-brand">Brands We Support</span>
                        <h2 className="mt-3 font-display text-2xl sm:text-3xl font-extrabold text-navy">
                            Vendor-neutral. Enterprise-grade.
                        </h2>
                    </div>
                    <p className="max-w-md text-slate-600 text-sm">
                        Authorised deployments and AMC coverage across the world&apos;s leading networking,
                        server and infrastructure brands.
                    </p>
                </div>
            </div>

            <Marquee gradient gradientColor="rgb(255,255,255)" gradientWidth={80} speed={40} pauseOnHover>
                {BRANDS.map((b) => (
                    <div
                        key={b}
                        data-testid={`brand-${b.toLowerCase()}`}
                        className="mx-6 sm:mx-10 flex items-center justify-center"
                    >
                        <span className="font-display text-2xl sm:text-3xl font-bold text-slate-400 hover:text-navy transition-colors">
                            {b}
                        </span>
                    </div>
                ))}
            </Marquee>
        </section>
    );
}
